import React from "react";
// reactstrap components
import {
    Button,
    Modal,
} from "reactstrap";
import './BasicModal.css'
import { useNavigate, useParams } from "react-router-dom";

function BasicModal(props) {
    const navigate = useNavigate();
    
    let toggleModal = () => {
        props.setShowModal(!props.showModal)
    };

    let handleClick = () => {
        if(!props.handleGoTo){
            toggleModal()
        }else{
            navigate(props.handleGoTo)
        }
    }

    return (
        <>

            <Modal
                className="modal-dialog-centered"
                isOpen={props.showModal}
                toggle={() => toggleModal()}
                backdrop="static" keyboard={false}
            >
                <div className="modal-header bg-white">
                    <h3 className="modal-title" id="exampleModalLabel">
                        {props.title}
                    </h3>
                </div>

                <div className="modal-body">
                    {props.message}
                </div>
                <div className="modal-footer">
                    <Button
                        className="btn-modal"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleClick()}
                    >
                        Close
                    </Button>
                </div>
            </Modal>


        </>
    );

}

export default BasicModal;